export const host = (
    window.location.host.indexOf('.uat.') > -1 ? 'https://anytrip-pids-server-uat.oci.jxeeno.com' :
    window.location.host.indexOf('.dev.') > -1 ? 'https://anytrip-pids-server-dev.oci.jxeeno.com' :
    'https://api.prod.nswtci.anytrip.com.au'
    // 'http://localhost:5010'
);